import { SizedBox } from "../../../components/UI/SizedBox";

export const AbonnementPlateforme = () => {
  return <SizedBox height={"100px"} />;
};
